import { render, staticRenderFns } from "./UnpaidClaims.vue?vue&type=template&id=084c4ba0"
import script from "./UnpaidClaims.vue?vue&type=script&lang=js"
export * from "./UnpaidClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports